export const ARCHE_ID = 'arche_advertising_optimization';
export const ARCHE_PATH = `/a/${ARCHE_ID}`;
